/* @flow-editor */
import _ from 'lodash'
import { Field, Flow } from 'services'

/**
 * Validation typename
 * @private
 * @memberof ValidationService
 */
const isManagedApplication = app => ['CONTEXTPARTICIPANT'].indexOf(app.type) === -1
const isWorkingDirectoryDisabled = app =>
  ['WEB-CHROME', 'WEB-FF', 'WEB-IE', 'WEB-HIE', 'WEB-HCHROME', 'WEB-IE-PROXY', 'WEB-EDGE'].indexOf(
    app.type
  ) >= 0
const isLaunchWithArgumentsDisabled = app =>
  ['WEB-IE', 'WEB-HIE', 'WEB-HCHROME', 'WEB-IE-PROXY'].indexOf(app.type) >= 0
const isTitleBarContainsDisabled = app =>
  !isManagedApplication(app) || ['WEB-CHROME', 'WEB-FF', 'WEB-EDGE'].indexOf(app.type) >= 0
const isFrameContainsDisabled = app =>
  !isManagedApplication(app) ||
  ['WEB-CHROME', 'WEB-FF', 'WEB-IE-PROXY', 'WEB-HIE', 'WEB-HCHROME', 'WEB-EDGE'].indexOf(
    app.type
  ) >= 0
const isUrlContainsDisabled = app =>
  !isManagedApplication(app) ||
  ['WEB-CHROME', 'WEB-FF', 'WEB-IE-PROXY', 'WEB-HIE', 'WEB-HCHROME', 'WEB-IE', 'WEB-EDGE'].indexOf(
    app.type
  ) < 0
const isProcessNameContainsDisabled = app =>
  !isManagedApplication(app) ||
  ['WEB-IE', 'WEB-IE-PROXY', 'WEB-HIE', 'WEB-HCHROME'].indexOf(app.type) >= 0
const isExecutablesPathContainsDisabled = app =>
  !isManagedApplication(app) ||
  ['WEB-CHROME', 'WEB-FF', 'WEB-IE', 'WEB-IE-PROXY', 'WEB-HIE', 'WEB-HCHROME', 'WEB-EDGE'].indexOf(
    app.type
  ) >= 0
const isTabbedBrowserApplication = app =>
  ['WEB-CHROME', 'WEB-FF', 'WEB-EDGE'].indexOf(app.type) >= 0
const appContainsEmptyValidator = (value, app) => {
  return (
    !_.isEmpty(app.type) &&
    (!isManagedApplication(app) ||
      app.type === 'HEADLESS' ||
      app.type === 'WEB-HIE' ||
      app.type === 'WEB-HCHROME' ||
      (!isTitleBarContainsDisabled(app) && app.titlebarcontains) ||
      (!isFrameContainsDisabled(app) && app.framecontains) ||
      (!isUrlContainsDisabled(app) && app.urlcontains) ||
      (!isProcessNameContainsDisabled(app) && app.processcontains) ||
      (!isExecutablesPathContainsDisabled(app) && app.executablepathcontains))
  )
}

const validateFlows = flows => {
  if (flows) {
    return _.every(flows, f => Flow.validateFlowObject(f))
  }
  return false
}

const validateFields = fields => {
  if (fields) {
    return _.every(fields, f => Field.validateFieldObject(f))
  }
  return false
}

/**
 * Returns whether a string is a valid regular expression
 */
const isRegExpValid = str => {
  try {
    new RegExp(str)
  } catch (error) {
    return false
  }
  return true
}

const self = {
  isWorkingDirectoryDisabled,
  isLaunchWithArgumentsDisabled,
  isTitleBarContainsDisabled,
  isFrameContainsDisabled,
  isUrlContainsDisabled,
  isProcessNameContainsDisabled,
  isExecutablesPathContainsDisabled,
  isManagedApplication,
  isTabbedBrowserApplication,
  appContainsEmptyValidator,
  validateFlows,
  validateFields,
  isRegExpValid
}

/**
 *
 * @module ValidationService
 * @namespace ValidationService
 * @version 1.0.0
 */
export default self
